export default __webpack_public_path__ + "static/media/christmasLogo.47fe1948.png";